import { render, staticRenderFns } from "./SmsVerificationInput.vue?vue&type=template&id=5b5a5e40&scoped=true"
import script from "./SmsVerificationInput.vue?vue&type=script&lang=js"
export * from "./SmsVerificationInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5a5e40",
  null
  
)

export default component.exports